module.exports = __webpack_public_path__ + "static/media/logout.f0d50743.svg";